import React from "react";
import Textfield from "Components/UI/Form/Textfield";
import { useNavigate } from "react-router-dom";
import InvoicesCombobox from "Components/Invoice/InvoicesCombobox";
import ClientArticlesCombobox from "Components/Article/ClientArticlesCombobox";

//MUI
import Grid from "@mui/material/Grid";

import PriceField from "Components/UI/Form/PriceField";

export default function ClientAccountFormGeneral({
  formData,
  invoices,
  clientArticles,
  handleInputChange,
}) {
  const navigate = useNavigate();
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Textfield label="Klientkonto ID" disabled value={formData.Id} />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <PriceField
            name="Amount"
            onChange={(newVal) => handleInputChange("Amount", newVal)}
            label="Belopp"
            value={formData.Amount}
            InputProps={
              {
                /*
              endAdornment: (
                <InputAdornment position="end">
                  {formData.CurrencyCode}
                </InputAdornment>
              ),
*/
              }
            }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <InvoicesCombobox
            label={"Faktura ID"}
            selectedInvoiceID={formData.InvoiceId ? formData.InvoiceId : null}
            onChange={(newVal) => handleInputChange("InvoiceId", newVal)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <ClientArticlesCombobox
            label={"Klientartikel ID"}
            clientArticles={clientArticles}
            selectedArticleID={
              formData.ClientArticleId ? formData.ClientArticleId : null
            }
            onChange={(newVal) => handleInputChange("ClientArticleId", newVal)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Textfield
            label="Betalnings ref"
            value={formData.PayedId}
            type="number"
            onChange={(e) => handleInputChange("PayedId", e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Textfield
            label="Bokförings ref"
            value={formData.BookRefId}
            type="number"
            onChange={(e) => handleInputChange("BookRefId", e.target.value)}
          />
        </Grid>
      </Grid>
    </>
  );
}
